import "./user.css";
import NaijaStates from "naija-state-local-government";
import AdminService from "../../services/admin.service";
import Preloader from "../../components/preloader/Preloader";
import toast from "react-hot-toast";
import { useEffect, useRef, useState } from "react";

const UpdateForm = ({ user, userId, setUser, currentUserRoles }) => {
	const [fetching, setFetching] = useState(false);
	const [userRoles, setUserRoles] = useState([]);
	const firstname = useRef();
	const lastname = useRef();
	const othername = useRef();
	const email = useRef();
	const phone = useRef();
	const staffnum = useRef();
	const department = useRef();
	const jobTitle = useRef();
	const dateOfBirth = useRef(); 
	const gender = useRef();
	const grade = useRef();
	const stateOfOrigin = useRef();
	const localGovt = useRef();
	const employmentLocation = useRef();
	const employmentDate = useRef();
	const pencomNumber = useRef();
	const nhf = useRef();
	const role = useRef();
	const active = useRef();

	const handleUpdate = (e) => {
		e.preventDefault();
		if (!firstname.current.value) return toast.error("No empty field is allowed");
		if (!lastname.current.value) return toast.error("No empty field is allowed");
		if (!othername.current.value) return toast.error("No empty field is allowed");
		if (!email.current.value) return toast.error("No empty field is allowed");
		if (!phone.current.value) return toast.error("No empty field is allowed");
		if (!staffnum.current.value) return toast.error("No empty field is allowed");
		if (!department.current.value)
			return toast.error("No empty field is allowed");
		if (!jobTitle.current.value) return toast.error("No empty field is allowed");
		if (!dateOfBirth.current.value)
			return toast.error("No empty field is allowed");
		if (!gender.current.value) return toast.error("No empty field is allowed");
		if (!grade.current.value) return toast.error("No empty field is allowed");
		if (!stateOfOrigin.current.value)
			return toast.error("No empty field is allowed");
		if (!localGovt.current.value) return toast.error("No empty field is allowed");
		if (!employmentLocation.current.value)
			return toast.error("No empty field is allowed");
		if (!employmentDate.current.value)
			return toast.error("No empty field is allowed");
		if (!pencomNumber.current.value)
			return toast.error("No empty field is allowed");
		if (!nhf.current.value) return toast.error("No empty field is allowed");
		if (!role.current.value) return toast.error("No empty field is allowed");
		if (!active.current.value) return toast.error("No empty field is allowed");

		const updatedUser = {
			firstname: firstname.current.value,
			lastname: lastname.current.value,
			middlename: othername.current.value,
			email: email.current.value,
			phone: phone.current.value,
			staffnum: staffnum.current.value,
			department: department.current.value,
			jobTitle: jobTitle.current.value,
			dateOfBirth: dateOfBirth.current.value,
			gender: gender.current.value,
			grade: grade.current.value,
			stateOfOrigin: stateOfOrigin.current.value,
			localGovt: localGovt.current.value,
			employmentLocation: employmentLocation.current.value,
			employmentDate: employmentDate.current.value,
			pencomNumber: pencomNumber.current.value,
			nhf: nhf.current.value,
			roles: role.current.value,
			active: active.current.value,
		};

		AdminService.updateUser(userId, updatedUser);
		window.location.reload();
	};

	const fetchRoles = async () => {
		setFetching(true);
		let res = await AdminService.getAllRoles();
		const data = res.allRoles;
		setUserRoles(data);
		setFetching(false);
	};

	useEffect(() => {
		fetchRoles();
	}, []);

	return (
		<>
			<form className="userUpdateForm">
				<div className="userUpdateLeft">
					<div className="userUpdateItem">
						<label>First Name</label>
						<input
							defaultValue={user.firstname}
							ref={firstname}
							type="text"
							className="userUpdateInput"
						/>
					</div>
					<div className="userUpdateItem">
						<label>Job Title</label>
						<input
							ref={jobTitle}
							type="text"
							defaultValue={user.jobTitle}
							className="userUpdateInput"
						/>
					</div>
					<div className="userUpdateItem">
						<label>Email</label>
						<input
							ref={email}
							type="email"
							defaultValue={user.email}
							className="userUpdateInput"
						/>
					</div>
					<div className="userUpdateItem">
						<label>Employment Location</label>
						<select
							className="userUpdateInput"
							defaultValue={user.employmentLocation}
							ref={employmentLocation}
						>
							{NaijaStates.states().map((state) => (
								<option value={state} key={state}>
									{state}
								</option>
							))}
						</select>
					</div>
					<div className="userUpdateItem">
						<label>Employment Date</label>
						<input
							type="text"
							defaultValue={user.employmentDate}
							ref={employmentDate}
							className="userUpdateInput"
							readOnly
						/>
					</div>
					<div className="userUpdateItem">
						<label>PENCOM Number</label>
						<input
							type="text"
							defaultValue={user.pencomNumber}
							ref={pencomNumber}
							className="userUpdateInput"
						/>
					</div>
				</div>
				<div className="userUpdateLeft">
					<div className="userUpdateItem">
						<label>Last Name</label>
						<input
							defaultValue={user.lastname}
							ref={lastname}
							type="text"
							className="userUpdateInput"
						/>
					</div>
					<div className="userUpdateItem">
						<label>Department</label>
						<input
							type="text"
							ref={department}
							defaultValue={user.department}
							className="userUpdateInput"
						/>
					</div>
					<div className="userUpdateItem">
						<label>Phone</label>
						<input
							type="text"
							ref={phone}
							defaultValue={user.phone}
							className="userUpdateInput"
						/>
					</div>

					<div className="userUpdateItem">
						<label>State of Origin</label>
						<input
							defaultValue={user.stateOfOrigin}
							ref={stateOfOrigin}
							type="text"
							className="userUpdateInput"
							readOnly
						/>
					</div>
					<div className="userUpdateItem">
						<label>Date of Birth</label>
						<input
							type="text"
							defaultValue={user.dateOfBirth}
							ref={dateOfBirth}
							className="userUpdateInput"
							readOnly
						/>
					</div>
					<div className="userUpdateItem">
						<label>NHF</label>
						<input
							type="text"
							defaultValue={user.nhf}
							ref={nhf}
							className="userUpdateInput"
						/>
					</div>
				</div>
				<div className="userUpdateLeft">
					<div className="userUpdateItem">
						<label>Other Name</label>
						<input
							defaultValue={user.middlename}
							ref={othername}
							type="text"
							className="userUpdateInput"
						/>
					</div>
					<div className="userUpdateItem">
						<label>Assign New Role</label>
						<select className="userUpdateInput" ref={role}>
							<option disabled selected>{currentUserRoles(user.roles)} (current)</option>
							{userRoles.map((item) => (
								<option key={item._id} value={item._id}>
									{item.name.toUpperCase()}
								</option>
							))}
						</select>
					</div>
					<div className="userUpdateItem">
						<label>Grade</label>
						<select defaultValue={user.grade} ref={grade} className="userUpdateInput">
							<option value="09">09</option>
							<option value="10">10</option>
							<option value="11">11</option>
							<option value="12">12</option>
							<option value="13">13</option>
							<option value="14">14</option>
							<option value="15">15</option>
							<option value="16">16</option>
						</select>
					</div>
					<div className="userUpdateItem">
						<label>Local Government</label>
						<input
							type="text"
							defaultValue={user.localGovt}
							ref={localGovt}
							className="userUpdateInput"
							readOnly
						/>
					</div>

					<div className="userUpdateItem">
						<label>Gender</label>
						<select
							className="userUpdateInput"
							defaultValue={user.gender}
							ref={gender}
						>
							<option value="male">Male</option>
							<option value="female">Female</option>
							<option value="others">Others</option>
						</select>
					</div>
					<div className="userUpdateItem">
						<label>Active</label>
						<select
							className="userUpdateInput"
							defaultValue={user.active === true ? "yes" : "no"}
							ref={active}
						>
							<option value="true">Yes</option>
							<option value="false">No</option>
						</select>
					</div>
					<div className="userUpdateInput staffNum">
						<label>Staff ID/Number</label>
						<input defaultValue={user.staffnum} ref={staffnum} type="text" readOnly />
					</div>
				</div>
			</form>
			<div className="userUpdateRight">
				<button type="submit" onClick={handleUpdate} className="userUpdateButton">
					Update
				</button>
			</div>
			{fetching && <Preloader text={"Fetching data"} />}
		</>
	);
};

export default UpdateForm;
